import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Tag, Typography } from "antd";
import useCurrentUserData from "../hooks/useCurrentUserData";
import { isImageSource, renderLooseNode } from "../utils/rewards";
import PageLoader from "./PageLoader";

const LogrosCarousel: React.FC = () => {
  const { userData, isLoading } = useCurrentUserData();
  const achievements = userData?.Logros ?? [];

  if (isLoading && !userData) {
    return <PageLoader minHeight={160} />;
  }

  if (!achievements.length) {
    return (
      <Typography.Text style={{ color: "var(--dashboard-text)" }}>
        No hay logros para mostrar.
      </Typography.Text>
    );
  }

  return (
    <Slider
      dots={false}
      arrows={false}
      infinite
      vertical
      verticalSwiping
      speed={1000}
      autoplaySpeed={5000}
      autoplay={false}
      slidesToShow={Math.min(5, achievements.length)}
      slidesToScroll={1}
    >
      {achievements.map((ach, index) => {
        const completed = ach.Status === "Completado";
        return (
          <div key={index}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: 12,
                margin: "4px 0",
                borderRadius: 16,
                background: completed
                  ? "rgba(79, 194, 134, 0.15)"
                  : "rgba(255, 255, 255, 0.85)",
                border: completed
                  ? "1px solid rgba(79, 194, 134, 0.5)"
                  : "1px solid var(--dashboard-panel-border)",
                opacity: completed ? 1 : 0.6,
              }}
            >
              <div
                style={{
                  fontSize: 32,
                  lineHeight: 1,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {typeof ach.Icon === "string" && isImageSource(ach.Icon) ? (
                  <img
                    src={ach.Icon}
                    alt={ach.Name}
                    style={{
                      width: 44,
                      height: 44,
                      objectFit: "contain",
                      borderRadius: 8,
                    }}
                  />
                ) : (
                  renderLooseNode(ach.Icon, "🏅")
                )}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <Typography.Text
                  strong
                  style={{
                    display: "block",
                    color: "var(--dashboard-header-blue)",
                    fontSize: 16,
                  }}
                >
                  {ach.Name}
                </Typography.Text>
                <Typography.Text style={{ color: "var(--dashboard-text)" }}>
                  {ach.Description}
                </Typography.Text>
              </div>

              {completed ? (
                <Tag
                  color="green"
                  style={{ fontWeight: 600, marginInlineEnd: 0 }}
                >
                  Completado
                </Tag>
              ) : null}
            </div>
          </div>
        );
      })}
    </Slider>
  );
};

export default LogrosCarousel;
